var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column justify-center align-center fill-width pa-3"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"35","width":"3","color":"primary"}}),_c('div',{staticClass:"caption text-center mt-2"},[_vm._v("loading data...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }